import { Box, Center } from "@chakra-ui/layout";
import { Button } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import type { TModuleSettings } from "@src/stores/models/types";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import React, { type FunctionComponent } from "react";
import allfredBrandsImageSrc from "./assets/Allfred-Brands.png";
import allfredContractorsImageSrc from "./assets/Allfred-Contractors.png";
import allfredDocumentsImageSrc from "./assets/Allfred-Documents.png";
import allfredFinancForInvoicingImageSrc from "./assets/Allfred-Financ-For invoicing.png";
import allfredFinanceCaImageSrc from "./assets/Allfred-Finance-CA.png";
import allfredFinanceExpensesImageSrc from "./assets/Allfred-Finance-Expenses.png";
import allfredFinanceOiImageSrc from "./assets/Allfred-Finance-OI.png";
import allfredFinanceProformaImageSrc from "./assets/Allfred-Finance-Proforma invoices.png";
import allfredPlanningImageSrc from "./assets/Allfred-Planning.png";
import allfredProjectsBudgetExceededImageSrc from "./assets/Allfred-Projects-Budget exceeded.png";
import allfredProjectsListImageSrc from "./assets/Allfred-Projects-List of projects.png";
import allfredProjectsMonthlyClosingImageSrc from "./assets/Allfred-Projects-Monthly closing.png";
import allfredProjectsTimeBillingImageSrc from "./assets/Allfred-Projects-Time billing.png";
import allfredReportsImageSrc from "./assets/Allfred-Reports.png";
import allfredTimeImageSrc from "./assets/Allfred-Time.png";

export enum Modules {
  Projects,
  ProjectsWip,
  ProjectsBudgetExceeded,
  ResourcePlanning,
  Clients,
  InvoicesForInvoicing,
  InvoicesCreditAccounts,
  InvoicesOutgoingInvoices,
  InvoicesProformaInvoices,
  Expenses,
  Contractors,
  TimeTracking,
  Reports,
  Documents,
  TimeBilling,
}

const modulesMap: Record<Modules, [keyof TModuleSettings, any]> = {
  [Modules.Projects]: ["projects", allfredProjectsListImageSrc],
  [Modules.ProjectsWip]: ["projects", allfredProjectsMonthlyClosingImageSrc],
  [Modules.ProjectsBudgetExceeded]: [
    "projects",
    allfredProjectsBudgetExceededImageSrc,
  ],
  [Modules.TimeBilling]: ["time_billing", allfredProjectsTimeBillingImageSrc],
  [Modules.ResourcePlanning]: ["planovac", allfredPlanningImageSrc],
  [Modules.Clients]: ["clients", allfredBrandsImageSrc],
  [Modules.InvoicesForInvoicing]: [
    "invoices",
    allfredFinancForInvoicingImageSrc,
  ],
  [Modules.InvoicesCreditAccounts]: ["invoices", allfredFinanceCaImageSrc],
  [Modules.InvoicesOutgoingInvoices]: ["invoices", allfredFinanceOiImageSrc],
  [Modules.InvoicesProformaInvoices]: [
    "invoices",
    allfredFinanceProformaImageSrc,
  ],
  [Modules.Expenses]: ["expenses", allfredFinanceExpensesImageSrc],
  [Modules.Contractors]: ["contractors", allfredContractorsImageSrc],
  [Modules.TimeTracking]: ["time_tracking", allfredTimeImageSrc],
  [Modules.Reports]: ["reports", allfredReportsImageSrc],
  [Modules.Documents]: ["documents", allfredDocumentsImageSrc],
};

const MODULE_SETTINGS = 0;
const IMAGE = 1;

interface DemoModuleProps {
  module: Modules;
}

const DemoModule: FunctionComponent<
  React.PropsWithChildren<DemoModuleProps>
> = ({ module, children }) => {
  const { workspaceStore } = useStore();

  const handleClick = () => {
    const subject = t`${workspaceStore.settings?.title} needs to upgrade plan`;
    window.location.assign(`mailto:support@allfred.io?subject=${subject}`);
  };

  if (
    workspaceStore.settings?.moduleSettings[modulesMap[module][MODULE_SETTINGS]]
  ) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <React.Fragment>
      <Box
        bgColor="black"
        pos="fixed"
        zIndex="0"
        w="100%"
        h="100%"
        top="53px"
        left="95px"
        opacity="0.4"
      />
      <img
        style={{
          height: "100%",
          width: "100%",
          zIndex: 1,
        }}
        src={modulesMap[module][IMAGE]}
        alt={t`Module`}
      />
      <Box
        paddingInline="12"
        paddingBlock="20"
        zIndex="0"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        bgColor="white"
        borderRadius="15px"
        pos="absolute"
      >
        <h1 className="flex text-4xl items-center justify-center font-bold">
          {t` I am not allowed to show you this screen.`}
        </h1>
        <h1 className="pt-10 flex text-4xl justify-center font-bold">
          {t`You haven't got permission.`}
        </h1>
        <div className="pt-10">
          <Center>
            <Button onClick={handleClick}>{t`Upgrade your plan`}</Button>
          </Center>
        </div>
      </Box>
    </React.Fragment>
  );
};

export default observer(DemoModule);
